import { connect } from "react-redux";
import Router from "next/router";
import PropTypes from "prop-types";
import Link from "next/link";

import { addRemoveUrl } from "@lib/filterUtil";
import Modal from "@components/Modal";
import { removeModal } from "@store/app/actions";
import ActiveFilters from "./ActiveFilters";
import FilterGroup from "./FilterGroup";
import {
  setGTMProductsFilterApply,
  setGTMProductsFilterRemove,
} from "@lib/GTMHelper";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// Filter footer buttons: bricostore uses the pill button system; altex/MG keep the yellow style.
const FILTER_APPLY_CLASS = isBricoStore
  ? "py-2 px-5 text-14px text-center w-full text-white bg-red-brand rounded-full"
  : "py-2 px-5 text-14px border-2 border-transparent bg-filterYellow w-full rounded-bl-lg rounded-tr-lg";
const FILTER_RESET_CLASS = isBricoStore
  ? "py-2 px-5 text-14px text-center w-full bg-red-soft border border-red-brand text-red-brand rounded-full"
  : "py-2 px-5 text-center text-14px border-2 border-filterYellow w-full rounded-bl-lg rounded-tr-lg";

const Filters = ({
  extractedFiltersParams,
  filters,
  activeFilters,
  totalProducts,
  removeModal,
  isInSearch,
  query,
}) => {
  const hasActiveFilters = Boolean(activeFilters?.length);

  const trackFilterChange = (filter) => {
    const operation =
      filter.filters.length === 0 ||
      filter.filters.every((filter) => filter.isActive)
        ? "remove"
        : "add";

    if (operation === "add") {
      setGTMProductsFilterApply({
        addedFilters: filter,
        activeFilters,
      });
    } else {
      setGTMProductsFilterRemove({
        removedFilters: filter,
        activeFilters,
      });
    }
  };

  const handleFilterMobileApply = (parentSlug, filter, generalSlugs) => {
    const filQuery = { ...extractedFiltersParams.filters };
    // we remove existing values for this filter group as we always send all active values in the callback
    parentSlug
      ? delete filQuery[parentSlug]
      : generalSlugs.forEach((slug) => delete filQuery[slug]);

    const url = addRemoveUrl(
      "add",
      filter.filters.map((filterOption) => ({
        filter: filterOption.attributeSlug || parentSlug,
        filterValue: filterOption.slug,
        replaceValue: false,
      })),
      filQuery,
      isInSearch ? "search" : "list",
      query || {}
    );

    trackFilterChange(filter);

    removeModal();
    Router.push(url);
  };

  return (
    <>
      <div className="hidden lg:block lg:w-1/5 lg:mt-3 sm:pr-6">
        <div className="Filters" id="catalog-filters-container">
          <ul data-test="FILTERS_LIST">
            {filters.map((filter, index) => (
              <FilterGroup
                filter={filter}
                isModal={false}
                key={index}
                isLast={index == filters.length - 1}
                onFilterMobileApply={handleFilterMobileApply}
                activeFilters={activeFilters}
              />
            ))}
          </ul>
        </div>
      </div>

      <Modal
        id="filters"
        header="Filtreaza"
        hasStickyHeader={true}
        hasStickyFooter={true}
        hasRadius={false}
        footer={
          <div>
            <div className="flex space-x-2">
              <button
                className={FILTER_APPLY_CLASS}
                onClick={() => removeModal()}
              >
                Vezi {totalProducts}{" "}
                {totalProducts !== 1 ? "produse" : "produs"}
              </button>
              {hasActiveFilters && (
                <Link href={activeFilters.find((el) => el.removeAll).removeUrl}>
                  <a
                    className={FILTER_RESET_CLASS}
                    onClick={() => removeModal()}
                  >
                    Sterge tot
                  </a>
                </Link>
              )}
            </div>
          </div>
        }
      >
        {hasActiveFilters && (
          <div className="Filters-group Filters-group--remove js-active-filters mb-4 ">
            <ActiveFilters activeFilters={activeFilters} />
          </div>
        )}
        <div className="md:mt-6">
          <div className="Filters" id="catalog-filters-container">
            <ul>
              {filters.map((filter, index) => (
                <FilterGroup
                  filter={filter}
                  isModal={true}
                  onFilterMobileApply={handleFilterMobileApply}
                  isLast={index == filters.length - 1}
                  key={index}
                  activeFilters={activeFilters}
                />
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
};

Filters.propTypes = {
  filters: PropTypes.array.isRequired,
  extractedFiltersParams: PropTypes.object.isRequired,
};

export default connect(null, {
  removeModal,
})(Filters);
